module.exports = __webpack_public_path__ + "static/img/loginimg.d5a5b74.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/login/loginimg.png
// module id = IxVf
// module chunks = 1